<template>
  <div class="form-group form-group--range" :class="classes">


    <div class="form-group--range__pop-up-wrapper">
      <n-pop-up top :style="`left: ${normalised * 100}%;`">
        <slot name="tooltip">{{control_value}}</slot>
      </n-pop-up>
    </div>
    <label v-if="label" :for="control_id" class="form-control__label">
      <slot name="label" :label="label">{{label}}</slot>
    </label>

    <div class="form-element__container">
      <!-- Prepend slot-->
      <div v-if="$slots['prepend']" class="form-control__addon form-control__addon--prepend">
        <slot name="prepend"></slot>
      </div>

      <!-- Control -->
      <div class="form-control__container">        
        <input type="range" :id="control_id" ref="controlEl" :style="`background-size: ${normalised * 100}% 100%`" @focus="fcOnFocus" @blur="fcOnBlur" class="form-control" v-model="control_value" :placeholder="_placeholder" v-bind="$attrs"  >
      </div>

      <!-- Append slot-->
      <div v-if="$slots['append']" class="form-control__addon form-control__addon--append">
        <slot name="append"></slot>
      </div>
    </div>

    <div class="flexbox row form-control__additional-content-slot">
      <!-- Errors -->
      <div v-if="show_error" class="form-control__error-text">{{errors[0]}}</div> 
      <!-- Helper slot -->
      <div v-else-if="$slots['help'] || $slots['default']" class="form-control__helper-text"> <!-- if there is no help, but default content, render an empty help block for flex spacing -->
        <slot name="help"></slot>
      </div>
      <!-- Default slot -->
      <slot></slot>
    </div>
    
  </div>
</template>

<script>
import FormControl from '../../mixins/form-control'
import Validatable from '../../mixins/validatable'
import { normalise } from '../../utils/helpers'

export default {

  name: 'NRange',

  mixins: [FormControl, Validatable],

  data() {
    return {
      hasMounted: false,
    }
  },

  computed: {
    normalised() {
      if(!this.hasMounted) return 0
      let min = this.$refs.controlEl.min
      let max = this.$refs.controlEl.max
      return normalise(this.control_value, min, max)
    }
  },

  mounted() {
    this.hasMounted = true
  },
}
</script>